<marv-item (click)="this.selectStore()">
    <div class="store_item">         
        
        <div class="store_content">
            <div class="store_content_infos">
                <div class="store_infos_and_logo">
                    <app-retailer-logo [retailer]="this.store.logoRetailer" />  
                    <div class="store_infos"> 
                        <ion-label>{{this.store.name}}</ion-label>
                        <ion-note>{{(this.store.administrativeArea ? this.store.administrativeArea+(this.store.zipCode ? this.store.zipCode : '')+' ' : '')}}{{this.store.city}}</ion-note>
                        @if(this.displayNbInterventions){
                            <div class="store_item_op">
                            @for(operation of this.store.operations; track $index){
                                <marv-tag size="small" [color]="this.missionTypeService.getColor(operation.type)">{{operation.name+' ('+operation.nbMissions+')'}}</marv-tag>
                            }
                            </div>
                        }
                    </div>
                </div>
                
                @if(this.displaySector){
                    <div class="store_sector">
                        <div class="store_sector_title">{{'SECTOR' | translate}}</div>
                        <div class="store_sector_name">{{(this.store.sector ? this.store.sector.name : '-')}}</div>
                    </div>
                }
                
            </div>    
            
            @if(this.displayQuota && this.quotaInfos?.quotaTotal !== null){
                <div class="quotas">
                    <div class="quota_total">{{this.roundQuota(this.quotaInfos.quotaTotal)}}</div>
                    <div class="quota quota_realized">
                        <div class="quota_label">{{'CONSUMED' | translate}}</div>
                        <div class="quota_value">{{this.roundQuota(this.quotaInfos.quotaRealized)}}</div>
                    </div>
                    <div class="quota quota_planned">
                        <div class="quota_label">{{'PLANNED_TO_COME' | translate}}</div>
                        <div class="quota_value">{{this.roundQuota(this.quotaInfos.quotaPlanned)}}</div>
                    </div>
                    <div class="quota quota_remaining">
                        <div class="quota_label">{{'BALANCE' | translate}}</div>
                        <div class="quota_value">{{this.roundQuota(this.quotaInfos.quotaRemaining)}}</div>
                    </div>
                </div>
            }

            @if(this.displayScores && this.store.scores.length > 0){
                <div class="store_scores">
                    @for(score of this.store.scores; track $index){
                        <marv-tag [color]="score.color">{{score.name}} : <b>{{score.score}}</b></marv-tag>
                    }
                </div>
            }
        </div>
        
        @if(this.displayBtnRemoveStore){
            <marv-button class="btn_remove_store" icon="close-outline" [rounded]="true" color="red" [disabled]="this.disabledBtnRemoveStore" (click)="this.removeStore($event)"/>
        }
    </div>
</marv-item>
